import { Pipe, PipeTransform } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { FileTemp } from '../entity/FileTemp';

@Pipe({
  name: 'transform'
})
export class TransformPipe implements PipeTransform {

  transform(value: FileTemp, ...size: string[]): string {
    if (isNullOrUndefined(value)) {
      throw new Error('no file!');
    }

    if (isNullOrUndefined(value.transform)) {
      return value.url;
    }

    const transformCode = size.find(s => s in value.transform);

    if (isNullOrUndefined(transformCode)) {
      return value.url;
    } else {
      return value.transform[transformCode];
    }
  }

}
